import client from "../../client";
import clientAuth from "../../clientAuth";
export default {
  get_setting_data: () => clientAuth.get(`setting`),
  store: (settingData) => clientAuth.post(`setting`, { json: settingData }),
};
